angular.module('gym.components').directive('editFormField', [
  '$window',
  function($window) {
    return {
      restrict: 'E',
      template: require('templates/components/contacts/forms/edit_form_field.html.slim'),
      scope: {
        field: '=',
        form: '=',
        units: '=',
        minDate: '=',
        errors: '=',
        disabled: '=',
        compact: '=',
        hideLabel: '=',
        isWizardStep: '=',
        optional: '=',
        variant: '@',
        checkboxInline: '=',
        useNativeDatepicker: '=',
        disableAutocomplete: '='
      },
      controller: [
        '$rootScope',
        '$scope',
        function($rootScope,
        $scope) {
          var ref,
        ref1,
        ref2;
          $scope.users = (ref = $rootScope.gym) != null ? ref.users : void 0;
          $scope.locations = (ref1 = $rootScope.gym) != null ? ref1.locations.filter(function(location) {
            return location.active;
          }) : void 0;
          $scope.currency = ((ref2 = $rootScope.gym) != null ? ref2.currency_symbol : void 0) || window.DATA.currency;
          $scope.id = Math.floor(Math.random() * 100000);
          $scope.getPlaceholder = function() {
            if ($scope.hideLabel && $scope.optional) {
              return `${$scope.field.label} (optional)`;
            } else {
              return $scope.field.label;
            }
          };
          $scope.getAutocomplete = function() {
            if ($scope.disableAutocomplete) {
              return 'off';
            } else {
              return 'on';
            }
          };
          $scope.getInputType = function() {
            var input;
            input = document.createElement('input');
            input.setAttribute('type',
        'date');
            if (input.type !== 'text') {
              return 'date';
            } else {
              return 'text';
            }
          };
          $scope.inputType = $scope.getInputType();
          $scope.isMobile = function() {
            return $window.innerWidth < 768;
          };
          angular.element($window).bind('resize',
        function() {
            return $scope.$apply();
          });
          return $scope.$on('$destroy',
        function() {
            return angular.element($window).unbind('resize');
          });
        }
      ]
    };
  }
]);
